import { Alert, AlertTitle } from "@mui/material"

type ErrorType = {
    children: React.ReactNode
}

const ErrorAlert = ({ children }: ErrorType) => {
    return <Alert severity="error" sx={{ boxShadow: '1px 1px 5px rgba(0,0,0,0.2)' }}>
        <AlertTitle>
            {children}
        </AlertTitle>
    </Alert>
}

export default ErrorAlert;